<section class="recursos-section">

  <div class="recursos-container">

    <!-- ===== MENU LATERAL ===== -->
    <div class="menu-lateral">

      <a href="https://occ.com.mx" class="menu-item">OCC MUNDIAL</a>

      <a href="" class="menu-item">BUZON DIGITAL ITSE</a>

      <a href="buzon.html" class="menu-item active">
        BUZÓN DIGITAL ITSE
      </a>

      <a href="innovacion.html" class="menu-item gray">
        INNOVACIÓN Y CALIDAD
      </a>

    </div>

    <!-- ===== CONTENIDO ===== -->
    <div class="contenido">

      <h2>Recursos Financieros</h2>

      <!-- ===== TABS ===== -->
      <ul class="nav nav-tabs custom-tabs">

        <li><button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">Cuotas Semestre</button></li>

        <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">Nuevo Ingreso 2025-2026</button></li>

        <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">Agosto24-Febrero25</button></li>

        <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">Enero24</button></li>

        <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab5">Agosto22-Enero23</button></li>

        <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab6">Semestre2022</button></li>

      </ul>

      <!-- ===== CONTENIDO DE TABS ===== -->
      <div class="tab-content box-content">

        <!-- TAB 1 -->
        <div class="tab-pane fade show active" id="tab1">
          <h5>CUOTAS DE SERVICIOS</h5>

          <ul class="pdf-list">
            <li><a href="assets/servicios/recursos_financieros/APORTACIONES VOLUNTARIAS 2026.pdf" target="_blank">CUOTAS DE SERVICIOS AGOSTO 2026</a></li>
            

            
          </ul>
        </div>

        <!-- TAB 2 -->
        <div class="tab-pane fade" id="tab2">
          <ul class="pdf-list">
            <li><a href="assets/servicios/recursos_financieros/REFERENCIAS BANCARIAS INGRESO 2026.xlsx" target="_blank">REFERENCIAS BANCARIAS INGRESO 2026</a></li>
            <li><a href="assets/servicios/recursos_financieros/REFERENCIAS BANCARIAS 2025.xlsx" target="_blank">REFERENCIAS BANCARIAS INGRESO 2025</a></li>
          </ul>
        </div>

        <!-- TAB 3 -->
        <div class="tab-pane fade" id="tab3">
          <h5>AGOSTO 2024 - FEBRERO 2025</h5>

          <ul class="pdf-list">
            <li><a href="assets/servicios/recursos_financieros/Administracion.xlsx" target="_blank">LICENCIATURA EN ADMINISTRACIÓN MODALIDAD MIXTA</a></li>
            <li><a href="assets/servicios/recursos_financieros/ADMINISTRACION2.xlsx" target="_blank">LICENCIATURA EN ADMINISTRACIÓN</a></li>
            <li><a href="assets/servicios/recursos_financieros/Gastronomia.xlsx" target="_blank">LICENCIATURA EN GASTRONOMÍA</a></li>
            <li><a href="assets/servicios/recursos_financieros/Turismo.xlsx" target="_blank">LICENCIATURA EN TURISMO</a></li>
            <li><a href="assets/servicios/recursos_financieros/Contador Publico.xlsx" target="_blank">LICENCIATURA EN CONTADOR PÚBLICO</a></li>
            <li><a href="assets/servicios/recursos_financieros/Animacion Digital.xlsx" target="_blank">INGENIERÍA EN ANIMACIÓN DIGITAL Y EFECTOS VISUALES</a></li>
            <li><a href="assets/servicios/recursos_financieros/Energias Renovables.xlsx" target="_blank">INGENIERÍA EN ENERGÍAS RENOVABLES</a></li>
            <li><a href="assets/servicios/recursos_financieros/Ferroviaria.xlsx" target="_blank">INGENIERÍA FERROVIARIA</a></li>
            <li><a href="assets/servicios/recursos_financieros/Industrias Alimentarias.xlsx" target="_blank">INGENIERÍA EN INDUSTRIAS ALIMENTARIAS</a></li>
            <li><a href="assets/servicios/recursos_financieros/Sistemas.xlsx" target="_blank">INGENIERÍA EN SISTEMAS COMPUTACIONALES</a></li>
            <li><a href="assets/servicios/recursos_financieros/Maestria.xlsx" target="_blank">MAESTRÍA EN ECONOMÍA SOCIAL Y SOLIDARIA</a></li>
          </ul>
        </div>

        <!-- TAB 4 -->
        <div class="tab-pane fade" id="tab4">
          <h5>ENERO 2024</h5>

          <ul class="pdf-list">
            <li><a href="assets/servicios/recursos_financieros/REF ADMINISTRACION.xlsx" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN ADMINISTRACIÓN</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF ADMINISTRACION MIXTA.xlsx" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN ADMINISTRACIÓN MODALIDAD MIXTA</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF GASTRONOMIA.xlsx" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN GASTRONOMÍA</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF TURISMO.xlsx" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN TURISMO</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF CONTABILIDAD.xlsx" target="_blank">REFERENCIAS BANCARIAS CONTADOR PÚBLICO</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF ADMINISTRACION MIXTA.xlsx" target="_blank">REFERENCIAS BANCARIAS ADMINISTRACIÓN MODALIDAD MIXTA</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF ENERGIAS R.xlsx" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN ENERGÍAS RENOVABLES</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF INDUSTRIAS.xlsx" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN INDUSTRIAS ALIMENTARIAS</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF ING ANIM DIGITAL.xlsx" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN ANIMACIÓN DIGITAL</a></li>
            <li><a href="assets/servicios/recursos_financieros/REF MAESTRIA.xlsx" target="_blank">REFERENCIAS BANCARIAS MAESTRÍA EN ECONOMÍA SOCIAL Y SOLIDARIA</a></li>
          </ul>
        </div>

        <!-- TAB 5 -->
        <div class="tab-pane fade" id="tab5">
          <h5>AGOSTO 2022 - ENERO 2023</h5>

          <ul class="pdf-list">
            <li><a href="assets/servicios/recursos_financieros/2023/ADMINISTRACION.xlsx" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN ADMINISTRACIÓN</a></li>
            <li><a href="assets/servicios/recursos_financieros/2023/GASTRONOMIA.xlsx" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN GASTRONOMÍA</a></li>
            <li><a href="assets/servicios/recursos_financieros/2023/TURISMO.xlsx" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN TURISMO</a></li>
            <li><a href="assets/servicios/recursos_financieros/2023/ENERGIAS.xlsx" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN ENERGÍAS RENOVABLES</a></li>
            <li><a href="assets/servicios/recursos_financieros/2023/INDUSTRIAS.xlsx" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN INDUSTRIAS ALIMENTARIAS</a></li>
            <li><a href="assets/servicios/recursos_financieros/2023/ANIMACION.xlsx" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN ANIMACIÓN DIGITAL</a></li>
            <li><a href="assets/servicios/recursos_financieros/2023/SISTEMAS.xlsx" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN SISTEMAS COMPUTACIONALES</a></li>
          </ul>
        </div>

        <!-- TAB 6 -->
        <div class="tab-pane fade" id="tab6">
          <h5>SEMESTRE 2022</h5>

          <ul class="pdf-list">
            
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN ADMINISTRACIÓN</a></li>
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN GASTRONOMÍA</a></li>
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS LICENCIATURA EN TURISMO</a></li>
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN ENERGÍAS RENOVABLES</a></li>
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN INDUSTRIAS ALIMENTARIAS</a></li>
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN SISTEMAS COMPUTACIONALES</a></li>
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS INGENIERÍA EN ANIMACIÓN DIGITAL</a></li>
            <li><a href="assets/servicios/recursos_financieros/" target="_blank">REFERENCIAS BANCARIAS MAESTRÍA</a></li>
            

          </ul>
        </div>

      </div>

    </div>

  </div>

</section>